import React from 'react'
import SidebarWidget from '../../../../widget/SidebarWidget/SidebarWidget'
import PaymentPageWidget  from './paymentPageWidget'
import NavWidge2 from '../../../../widget/Nav/NavWidget2'
function Payment() {
  return (
    <div>
        <NavWidge2/>
        <div className='row'>
            <div className='col s12 m2 transparent'>
                <SidebarWidget/>
            </div>
            <div className='col s12 m10'>
                {/* <div className='container'> */}
                   <PaymentPageWidget/>
                {/* </div> */}
            </div>
        </div>
    </div>
  )
}

export default Payment